/**
 * 缓存说明:工作流缓存
 */
import vm from '@/cache/storeTools.js'
import flowApi from '@/components/api/order/flowApi.js'

var basestate = {
	flowList:undefined,
	flowIdToTree:{}
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getFlowList(state){
			return flowType=>{
				if(state.flowList == undefined){
					store.commit("getFlowList")
					return []
				}
				return state.flowList.filter(item=>{
					var type = item.userId == undefined ?0:1
					return flowType == type
				})
			}
		},
		getFlowTreeByFlowId(state){
			return flowId=>{
				if(state.flowIdToTree[flowId] == undefined){
					store.commit('getFlowTreeByFlowId',flowId)
				}
				return state.flowIdToTree[flowId]
			}
		}
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		getFlowList(state,len){
			if(len==undefined){
				len = 100
			}
			flowApi.getFlowLimit(1,len,respon=>{
				//现在写死获取一百，后面再说
				vm.Vue.set(state,'flowList',respon.dataList)
			})
		},
		getFlowTreeByFlowId(state,flowId){
			flowApi.getFlowTree(flowId,respon=>{
				vm.Vue.set(state.flowIdToTree,flowId,respon)
			})
		}
	}
})

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */